export default "__VITE_ASSET__ed285561__"